import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
  }

  hideMenu() {
    if (document.body.clientWidth < 1280) {
      return;
    }

    document.body.classList.remove("menu-open");
    document.querySelector("header nav ul.main").querySelectorAll(".open")
      .forEach(
        (element) => {
          element.classList.remove(
            "open",
          );
        },
      );
  }

  showMenu() {
    this.dispatch("showMenu");
  }

  closeMenu() {
    this.dispatch("closeMenu");
  }
}
